import * as T from 'three'

/** Notched planning stringer. Tread seats touch every tread underside.
 * Stock and connections remain subject to final design, not a cut list. */
export function stringerOutline(count: number, run: number, rise: number, firstTreadTop: number) {
  const webDepth = 12,
    top = firstTreadTop - 1
  const points = [new T.Vector2(0, top)]
  for (let i = 0; i < count; i++) {
    points.push(new T.Vector2(-(i + 1) * run, top - i * rise))
    if (i < count - 1) points.push(new T.Vector2(-(i + 1) * run, top - (i + 1) * rise))
  }
  points.push(new T.Vector2(-count * run, 0), new T.Vector2((-Math.max(0, top - webDepth) * run) / rise, 0), new T.Vector2(0, Math.max(0, top - webDepth)))
  return points
}

function extrudeOutline(points: T.Vector2[], thickness: number) {
  const shape = new T.Shape(points)
  shape.closePath()
  const geometry = new T.ExtrudeGeometry(shape, { depth: thickness, bevelEnabled: false, steps: 1 })
  geometry.rotateY(Math.PI / 2)
  geometry.scale(1 / 12, 1 / 12, 1 / 12)
  return geometry
}

export function stringerGeometry(count: number, run: number, rise: number, firstTreadTop: number) {
  return extrudeOutline(stringerOutline(count, run, rise, firstTreadTop), 1.5)
}

/** Horizontal 6-inch courses with real ⅛-inch recessed nickel gaps.
 * Clip every course to the notched stringer, preserving the open risers. */
export function stringerNickelGapGeometry(count: number, run: number, rise: number, firstTreadTop: number) {
  const outline = stringerOutline(count, run, rise, firstTreadTop)
  function clip(points: T.Vector2[], height: number, above: boolean) {
    const result: T.Vector2[] = []
    for (let i = 0; i < points.length; i++) {
      const a = points[i], b = points[(i + 1) % points.length]
      const insideA = above ? a.y >= height : a.y <= height
      const insideB = above ? b.y >= height : b.y <= height
      if (insideA) result.push(a)
      if (insideA !== insideB) result.push(new T.Vector2(a.x + (b.x - a.x) * (height - a.y) / (b.y - a.y), height))
    }
    return result
  }
  const courses: T.BufferGeometry[] = []
  for (let bottom = 0; bottom < firstTreadTop - 1; bottom += 6) {
    const points = clip(clip(outline, bottom === 0 ? 0 : bottom + 0.0625, true), bottom + 6 - 0.0625, false)
    if (points.length >= 3) courses.push(extrudeOutline(points, 0.125))
  }
  return courses
}

